module.exports = __webpack_public_path__ + "static/img/stripes3.7c54d97d.svg";